import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VContainer,
    { attrs: { fluid: "", "grid-list-xl": "" } },
    [
      _c("app-diagnostico", {
        attrs: {
          titulo: "Autoavaliação (Competências Técnicas)",
          inicio: _vm.diagnostico.inicioResponsabilidadeServidor,
          fim: _vm.diagnostico.fimResponsabilidadeServidor,
          avaliado: _vm.avaliado,
        },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _vm.semResponsabilidades
                  ? _c(
                      VCol,
                      [
                        _c("app-alert", {
                          attrs: {
                            type: "warning",
                            icon: "warning",
                            message:
                              "Não há responsabilidades disponíveis para realizar a avaliação.",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm.usuarioMapeamento.tipo != "REGULAR"
                  ? _c(
                      VCol,
                      [
                        _c("info-dispensa", {
                          attrs: {
                            mensagem: "Usuário não realiza esta avaliação.",
                          },
                        }),
                      ],
                      1
                    )
                  : _c(
                      VCol,
                      { attrs: { centered: "", cols: "12", "no-gutters": "" } },
                      [
                        _c("avaliacao", {
                          attrs: {
                            titulo: "AUTOAVALIAÇÃO",
                            diagnostico: _vm.diagnostico,
                            tipo: "AUTOAVALIACAO",
                            perspectiva: "RESPONSABILIDADE",
                            inicio: _vm.diagnostico.inicioComportamental,
                            fim: _vm.diagnostico.fimComportamental,
                            tutorial: { nome: "AutoavaliacaoResponsabilidade" },
                          },
                        }),
                      ],
                      1
                    ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }